module.exports = __webpack_public_path__ + "static/img/brees-2020-slide-1.86a4811.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2020-slide-1.jpg
// module id = YJal
// module chunks = 1